/* global google */

'use strict';

const SELECTORS = {
    addressField: 'input[name$="_address1"]'
};

let componentForm = {
    country: 'select[name$="_country"]',
    locality: 'input[name$="_city"]',
    administrative_area_level_1: 'select[name$="_stateCode"]',
    postal_code: 'input[name$="_postalCode"]'
};

function initAutocomplete() {
    if (window.SitePreferences && SitePreferences.GOOGLE_PLACES_AUTOCOMPLETE === true) {
        var interval = setInterval(() => {
            // Ensure Google Places API is available and enabled in SitePreferences
            if (typeof google !== 'undefined' && google.maps) {
                attachAutocomplete();
                clearInterval(interval);
            }
        }, 300);
    }
}

function attachAutocomplete() {
    let $addressFields = $(SELECTORS.addressField);

    $addressFields.each(function (i, el) {
        const existingPlaceholder = $(this).attr('placeholder') || 'Enter an address';
        $(this).attr('placeholder', existingPlaceholder); // Preserve placeholder

        const autocompleteOptions = {
            types: ['address'], // Use 'address' for more precise results
            componentRestrictions: { country: ['us'] },
            fields: ['address_components','formatted_address','geometry','place_id','name']
        };

        let autocomplete = new google.maps.places.Autocomplete($(this)[0], autocompleteOptions);

        autocomplete.addListener('place_changed', function () {
            let place = autocomplete.getPlace();
            let state = '', stateName = '';

            if (place.address_components) {
                for (const component of place.address_components) {
                    if (component.types.includes("administrative_area_level_1")) {
                        state = component.short_name;
                        stateName = component.long_name;
                    }
                }
            }

            if (state === "HI") {
                alert("Shipping to Hawaii is not supported.");
            }
            if (state === "AK") {
                alert("Shipping to Alaska is not supported.");
            }

            fillInAddress(autocomplete, el, state, stateName);
        });
    });
}

function fillInAddress($this, el, state, stateName) {
    let place = $this.getPlace();
    let $form = $(el).closest('form');
    let streetNumber = '';
    let route = '';

    for (let i = 0; i < place.address_components.length; i++) {
        let addressType = place.address_components[i].types[0];
        let val = place.address_components[i].long_name;

        if (addressType === 'street_number') {
            streetNumber = val;
        } else if (addressType === 'route') {
            route = val;
        } else if (componentForm[addressType]) {
            // Skip Country value
            if (addressType === 'country') {
                continue;
            }

            let $field = $form.find(componentForm[addressType]);
            if ($field.length) {
                $field.val(val);

                // Ensure dropdown change event is triggered properly
                if ($field.prop('tagName') === 'SELECT' && $form.attr('data-address-mode') !== 'new') {
                    $field.trigger('change');
                }
            }
        }
    }

    // Properly format and set the street address (Address1)
    let formattedStreetAddress = streetNumber ? `${streetNumber} ${route}` : route;
    $(el).val(formattedStreetAddress);

    // Handle state selection properly
    let $stateField = $form.find(componentForm['administrative_area_level_1']);
    if ($stateField.length) {
        let stateOption = $stateField.find(`option[value="${state}"], option:contains("${stateName}")`);
        if (stateOption.length) {
            $stateField.val(stateOption.val()).trigger('change');
        }
    }
}

exports.init = function () {
    initAutocomplete();
}
